import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";

const AddTextModal = ({
  text,
  openState,
  closeFunction,
  btnClickFunc1,
  loader,
  label,
  placeholder,
}) => {
  const [textContent, setTextContent] = useState("");

  useEffect(() => {
    setTextContent(text ?? "");
  }, [text]);

  const noteExists = textContent.trim().length > 0;

  return (
    <Modal open={openState} onClose={closeFunction} sx={{ border: "none" }}>
      <div className="fixed inset-0 flex items-center justify-center bg-[#7876A1]/50 px-4">
        <div className="bg-white w-full max-w-[340px] rounded-2xl p-6 shadow-lg">
          {/* Label */}
          <div className="text-[18px] font-semibold mb-4">
            {label ? label : "Add/Edit Note"}
          </div>

          {/* Textarea */}
          <textarea
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            placeholder={placeholder ?? "Type your note here..."}
            rows={4}
            className="w-full border border-gray-300 rounded-lg p-3 text-sm resize-none mb-6 focus:outline-none "
          />

          {/* Buttons */}
          <div className="flex flex-col gap-3">
            <button
              onClick={() => btnClickFunc1(textContent)}
              disabled={textContent.trim().length === 0}
              className="w-full bg-[#34318C] text-white py-3 disabled:opacity-50 rounded-[15px] font-semibold text-base hover:bg-[#2d2a6b] transition-colors"
            >
              {noteExists ? "Update Note" : "Add Note"}
            </button>

            <button
              onClick={() => {
                closeFunction();
                if (textContent.trim().length === 0) {
                  setTextContent("");
                  btnClickFunc1("");
                }
              }}
              className="w-full bg-gray-200 text-gray-800 py-3 rounded-[15px] font-semibold text-base hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>
          </div>

          {/* Loader */}
          {loader && (
            <div className="mt-4 flex justify-center">
              <CircularProgress color="secondary" />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddTextModal;
